import React, { useState } from 'react';
import { signIn } from './auth';
import './Login.css';

/*
  Sign-in screen for the odds screen.

  Shown by index.js when there is no usable session. The password lives only in
  this component's state and is handed straight to signIn() — it is never
  persisted. See docs/kibl-screen-authentication.md.
*/
export default function Login({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;

    const user = username.trim();
    if (!user || !password) {
      setError('Enter your username and password.');
      return;
    }

    setBusy(true);
    setError('');

    try {
      const session = await signIn(user, password);
      // Clear before handing off — onSuccess reloads into the app and this
      // component unmounts, but do not leave the password sitting in state
      // while the reload is in flight.
      setPassword('');
      onSuccess(session);
    } catch (err) {
      setError(err.message || 'Unable to sign in.');
      setBusy(false);
    }
  };

  return (
    <div className="kibl-login-backdrop">
      <form className="kibl-login-card" onSubmit={submit}>
        <h1 className="kibl-login-title">KIBL ODDS SCREEN</h1>

        <label className="kibl-login-label" htmlFor="kibl-login-username">
          Username
        </label>
        <input
          id="kibl-login-username"
          className="kibl-login-input"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck="false"
          autoFocus
          disabled={busy}
        />

        <label className="kibl-login-label" htmlFor="kibl-login-password">
          Password
        </label>
        <input
          id="kibl-login-password"
          className="kibl-login-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          disabled={busy}
        />

        {/* role=alert so a screen reader announces a failed attempt */}
        {error && <div className="kibl-login-error" role="alert">{error}</div>}

        <button className="kibl-login-button" type="submit" disabled={busy}>
          {busy ? 'Signing In…' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
